import Controller from '@ember/controller';
import { action, set } from '@ember/object';
import { inject as service } from '@ember/service';
import { ApplicationFlowUpdate } from '@square/dashboard-protos/models/squareup/sfs/external/models/application_flow_update';
import { initializeAction } from '@banking/ui/workflows/onboarding-kyb/action';

export default class EnterBusinessInfoController extends Controller {
  @service currentApplicationFlow;
  @service addressValidation;
  @service kybWorkflow;
  @service router;

  @action async onUpdateBusiness(businessUpdate) {
    try {
      if (!this.addressValidation.didShowBusinessValidation) {
        await this.addressValidation.validateAndStandardizeBusiness(
          businessUpdate.address
        );
      }

      let hasSignificantChanges = false;

      const applicationFlowUpdate = new ApplicationFlowUpdate.Builder()
        .id(this.currentApplicationFlow.id)
        .business(businessUpdate)
        .build();

      if (
        !this.addressValidation.businessFailedValidation &&
        !this.addressValidation.didShowBusinessValidation
      ) {
        applicationFlowUpdate.business.address =
          this.addressValidation.businessStandardizedAddress;
        hasSignificantChanges = this.addressValidation.hasSignificantChanges(
          this.addressValidation.businessStandardizationChanges
        );
      }

      await this.currentApplicationFlow.update(applicationFlowUpdate);

      if (
        this.addressValidation.businessFailedValidation &&
        !this.addressValidation.didShowBusinessValidation
      ) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.enter-business-info.invalid-address');
      } else if (hasSignificantChanges) {
        set(this, 'addressValidation.didShowBusinessValidation', true);
        this.router.transitionTo('signup.enter-business-info.address');
      } else {
        this.initKyb();
      }
    } catch (error) {
      this.send('handleRpcError', error);
    }
  }

  initKyb() {
    const initialize = initializeAction({
      businessName: this.currentApplicationFlow.business?.businessName,
      entityType: this.currentApplicationFlow.business?.businessType,
      taxIdSerialNumber: this.currentApplicationFlow.business?.businessEinLast4,
      existingIndividuals: this.currentApplicationFlow.controllingIndividuals,
    });

    this.kybWorkflow.emit(initialize);
  }
}
